// Konfiguracja dla API backendu Orion (Chat Assistant)

import axios from 'axios';
import { store } from 'store';
import i18n from 'i18n';

const ORION_API_BASE_URL = process.env.REACT_APP_CHAT_API_BASE_URL ?? 'http://localhost:5427';

/**
 * Instancja axios dla Orion backend
 * 
 * UWAGA: NIE używamy interceptorów normalizujących odpowiedzi
 * Backend Orion zwraca surowe wartości (UUID jako string, itp.)
 */
export const orionAxios = axios.create({
  baseURL: ORION_API_BASE_URL,
  withCredentials: true
});

// Interceptor dodający nagłówki autoryzacji
orionAxios.interceptors.request.use((config) => {
  const authToken = store.getState().auth.token;
  const headers: { [key: string]: string } = {
    'Content-Language': i18n.language
  };

  if (authToken) {
    headers['Authorization'] = `Bearer ${authToken}`;
  }

  config.headers = {
    ...config.headers,
    ...headers
  };

  return config;
});

export { ORION_API_BASE_URL };

